import React, { useState, useEffect, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { toast } from "react-toastify";
import useLatLng from "../../../../../hooks/uselatlng/uselatlng";
import FileUpload from "../../../../../components/sales/fileUpload/fileUpload";
import { Button } from "react-bootstrap";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import './raise_payment.css'

const PaymentRaiseV2 = ({
    match,
    history,
    documentUploadUrlPublic,
    documentUrlDataPublic,
    bankListResponse = [],
    bankListRequest,
    loanUndertakingRequest,
    loanAccountRequest,
    loanPaymentRaiseRequest,
    loanPaymentRaiseUpdateResponse = [],
    loanAccountResponse = [],
    loanTranchesRequest,
    loanTranchesResponse = [],
    loanPaymentRaiseUpdateRequest,
    loanApplicationByIdRequest,
    ucdCaseByIdResponse = [],
    loanPaymentRaiseResponse = [],
    newBankDetailsRequest,
    newBankDetailsResponse = [],
    loanApprovalRequestRequest,
    loanApprovalRequestResponse = [],
    foreClosureAddAccountRequest,
    foreClosureAddAccountResponse = []
}) => {
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([{
        payment_details: {
            existing_loan: '',
            for_closure_amount: '',
            // fc_closure_amount_proof: '',
            prev_loan_closure: '',
            mode_of_payment: '',
            loan_closure_payment_proof: '',
        },
        dealer_details: {
            account_number: '',
            bank_name: '',
            ifsc_code: '',
            branch_name: '',
        },
        hold_back_Details: {
            amount_approval_proof: '',
            amount: '',
            account_id: '',
            mode_of_payment: '',
            remark: '',
            status: ''
        },
        undertaking: {
            undertaking: ''
        }
    }]);

    const [otherBankName, setBankName] = useState(true);
    const [stage, setStage] = useState(1);
    const [tranches, setTranches] = useState([{ amount: '', account_id: '', payment_mode: '', remark: '' }])
    const [bankAmountLoanReceived, setBankAmountLoanReceived] = useState([{
        loan_amount_received_from_bank: '',
        bank_transfer_utr_number: ''
    }])
    const [amountReceivedEdit, setAmountReceivedEdit] = useState([])
    const [accountHolder, setAccountHolder] = useState([{
        fore_closure_amount: "",
        account_number: '',
        bank_name: '',
        ifsc_code: '',
        branch_name: '',
        other_bank: '',
        utr_no: '',
        tranche_id: '',
        mode_of_payment: '',
        fc_closure_amount_proof: ''
    }]);
    const [accountHolderEdit, setAccountHolderEdit] = useState([])
    const [isEdit, setIsEdit] = useState(false)
    let [totalReceivedAmount, setTotalReceivedAmount] = useState(0)
    const [checkDisbursalMemo, setCheckDisbursalMemo] = useState(false);
    const [amountReceived, setAmountReceived] = useState(0)
    const [isAccountCreated, setIsAccountCreated] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await bankListRequest()
            await newBankDetailsRequest()
            await loanAccountRequest(match?.params?.id)
            await loanTranchesRequest(match?.params?.id)
            await loanApplicationByIdRequest(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    const handleInput = (val, index, e = '', key = '') => {
        const list = [...inputList]
        list[0][key][index] = '';
        list[0][key][index] = val
        setInputList(list)
    }


    const handleSubmit = async (e) => {
        e.preventDefault()
        let requestParams = inputList[0];
        if (stage < 5) {
            return false;
        }
        if (bankAmountLoanReceived[0] && !bankAmountLoanReceived[0]['loan_amount_received_from_bank']) {
            toast.error("Bank transfer loan details is required!");
            return;
        }

        let isValidate = false;
        let msg = '';
        if (requestParams['payment_details']['prev_loan_closure'] === 'Park+') {
            accountHolder.some(val => {
                if (!val?.fore_closure_amount) {
                    // isValidate = true;
                    // msg = ;
                    toast.error("Amount is missing");
                    return;
                }

                if (!val?.ifsc_code) {
                    // isValidate = true;
                    // msg = ;
                    toast.error("IFSC Code k is missing");
                    return;
                }

                if (!val?.account_number) {
                    toast.error("Account no is missing");
                    // isValidate = true;
                    // msg = "Bank transfer utr no is missing";
                    return;
                }
                if (!val?.bank_name) {
                    toast.error("Bank name is missing");
                    // isValidate = true;
                    // msg = "Bank transfer utr no is missing";
                    return;
                }
                if (!val?.branch_name) {
                    toast.error("Branch name is missing");
                    // isValidate = true;
                    // msg = "Bank transfer utr no is missing";
                    return;
                }
                if (!val?.utr_number) {
                    toast.error("UTR no is missing");
                    // isValidate = true;
                    // msg = "Bank transfer utr no is missing";
                    return;
                }
                if (!val?.mode_of_payment) {
                    toast.error("Mode of payment is missing");
                    return;
                }
                if (!val?.fc_closure_amount_proof) {
                    toast.error("Amount proof is missing");
                    return;
                }
            });
        }

        if (!requestParams['payment_details']['existing_loan']) {
            requestParams['payment_details']['existing_loan'] = ucdCaseByIdResponse?.data?.existing_loan ? "Yes" : "No"
        }

        if (!requestParams['payment_details']['for_closure_amount']) {
            requestParams['payment_details']['for_closure_amount'] = ucdCaseByIdResponse?.data?.fore_closure_amount
        }

        // if(!requestParams['payment_details']['fc_closure_amount_proof']){
        //     requestParams['payment_details']['fc_closure_amount_proof'] = ucdCaseByIdResponse?.data?.fore_closure_amount_proof
        // }

        if (!requestParams['payment_details']['prev_loan_closure']) {
            requestParams['payment_details']['prev_loan_closure'] = ucdCaseByIdResponse?.data?.previous_loan_closed_by
        }

        if (!requestParams['payment_details']['mode_of_payment'] && requestParams['payment_details']['prev_loan_closure'] === 'Bank') {
            requestParams['payment_details']['mode_of_payment'] = ucdCaseByIdResponse?.data?.mode_of_payment
        }

        // if(!requestParams['payment_details']['loan_amount_from_bank']){
        //     requestParams['payment_details']['loan_amount_from_bank'] = ucdCaseByIdResponse?.data?.loan_amount_received_from_bank
        // }

        // if(!requestParams['payment_details']['utr_no']){
        //     requestParams['payment_details']['utr_no'] = ucdCaseByIdResponse?.data?.bank_transfer_utr_number
        // }

        if (!requestParams['payment_details']['loan_closure_payment_proof']) {
            requestParams['payment_details']['loan_closure_payment_proof'] = ucdCaseByIdResponse?.data?.loan_closure_payment_proof
        }

        if (!requestParams['hold_back_Details']['account_id']) {
            requestParams['hold_back_Details']['account_id'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.account_id;
        }

        if (!requestParams['hold_back_Details']['mode_of_payment']) {
            requestParams['hold_back_Details']['mode_of_payment'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode;
        }

        if (!requestParams['hold_back_Details']['remark']) {
            requestParams['hold_back_Details']['remark'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.remark;
        }

        if (!requestParams['hold_back_Details']['amount']) {
            requestParams['hold_back_Details']['amount'] = ucdCaseByIdResponse?.data?.hold_back_amount;
        }

        if (!requestParams['hold_back_Details']['amount_approval_proof']) {
            requestParams['hold_back_Details']['amount_approval_proof'] = ucdCaseByIdResponse?.data?.hold_back_amount_proof;
        }

        if (!requestParams['undertaking']['undertaking']) {
            requestParams['undertaking']['undertaking'] = ucdCaseByIdResponse?.data?.customer_undertaking;
        }

        requestParams['bank_transfer_loan_details'] = bankAmountLoanReceived;
        if (inputList[0]['payment_details']['prev_loan_closure'] === 'Bank') {
            bankAmountLoanReceived.some(val => {
                if (!val?.loan_amount_received_from_bank) {
                    // isValidate = true;
                    // msg = ;
                    toast.error("Amount received from bank is missing");
                    return;
                }

                if (!val?.bank_transfer_utr_number) {
                    toast.error("Bank transfer utr no is missing");
                    // isValidate = true;
                    // msg = "Bank transfer utr no is missing";
                    return;
                }
            });
        }


        if (isValidate) {
            toast.error(msg);
            return;
        }

        requestParams['tranches'] = tranches;
        requestParams['case_id'] = match?.params?.id;

        // console.log("requestParamsrequestParams "+JSON.stringify(requestParams))
        // return
        setIsAccountCreated(false);
        setIsLoading(true);
        if (requestParams['payment_details']['prev_loan_closure'] === 'Park+') {
            await foreClosureAddAccountRequest({
                loan_application_id: match?.params?.id,
                fore_closure_payment_details: accountHolder,
                total_fore_closure_amount: requestParams['payment_details']['for_closure_amount']
            });
        } else {
            await handleFinalHit();
        }
        setIsLoading(false);
    }


    const handleFinalHit = async () => {
        setIsLoading(true);
        let requestParams = inputList[0];
        requestParams['tranches'] = tranches;
        requestParams['case_id'] = match?.params?.id;
        requestParams['bank_transfer_loan_details'] = bankAmountLoanReceived;
        if (ucdCaseByIdResponse?.data && ucdCaseByIdResponse?.data?.status !== 'APPROVED') {
            console.log("update")
            await loanPaymentRaiseUpdateRequest(requestParams)
        } else {
            console.log("create")
            await loanPaymentRaiseRequest(requestParams)
        }
        setIsLoading(false);
    }
    useEffect(() => {
        (async () => {
            if (isAccountCreated) {
                await handleFinalHit()
            }
        })();
    }, [isAccountCreated]);

    const handleAddTranches = () => {
        setTranches([
            ...tranches, { amount: '', account_id: '', payment_mode: '', remark: '' }
        ]);
    }

    const handleRemoveTranches = (e, index) => {
        e.preventDefault();
        let list = [...tranches]
        list.splice(index, 1);
        setTranches(list)
    }

    const handleTrancheInput = (val, key, index) => {
        const list = [...tranches]
        list[index][key] = val
        setTranches(list)
    }

    const handleAddAmountReceivedFromBank = () => {
        setBankAmountLoanReceived([
            ...bankAmountLoanReceived, { loan_amount_received_from_bank: '', bank_transfer_utr_number: '' }
        ]);
    }

    const handleRemoveAmountReceivedFromBank = (e, index) => {
        e.preventDefault();
        let list = [...bankAmountLoanReceived]
        list.splice(index, 1);
        setBankAmountLoanReceived(list)
    }

    const handleAmountReceivedFromBankInput = (val, key, index) => {
        const list = [...bankAmountLoanReceived]
        list[index][key] = val
        totalReceivedAmount = 0
        list.map(val => {
            totalReceivedAmount += parseInt(val?.loan_amount_received_from_bank);
        });
        console.log(totalReceivedAmount)
        setTotalReceivedAmount(totalReceivedAmount);
        setBankAmountLoanReceived(list)
    }


    const handleStage = stageNo => {
        let list = [...inputList];
        setCheckDisbursalMemo(false);
        let isTrue = false;
        let errorMsg = '';
        if (stageNo - 1 === 1) {
            if (!bankAmountLoanReceived[0]['loan_amount_received_from_bank']) {
                toast.error("Bank transfer loan details is required!");
                return;
            }

            if (list[0]['payment_details']['prev_loan_closure'] === 'Park+') {
                accountHolder.some(val => {
                    if (!val?.fore_closure_amount) {
                        isTrue = true;
                        errorMsg = "Fill all the details";
                        return;
                    }
                    if (!val?.account_number) {
                        // toast.error("Account no is missing");
                        isTrue = true;
                        errorMsg = "Fore closure account no is missing";
                        return;
                    }
                    if (!val?.ifsc_code) {
                        isTrue = true;
                        errorMsg = 'Fore closure IFSC Code is missing';
                        // toast.error("IFSC Code is missing");
                        return;
                    }

                    if (!val?.bank_name) {
                        // toast.error("Bank name is missing");
                        isTrue = true;
                        errorMsg = "Fore closure bank name is missing";
                        return;
                    }
                    if (!val?.branch_name) {
                        // toast.error("Branch name is missing");
                        isTrue = true;
                        errorMsg = "Fore closure branch name is missing";
                        return;
                    }
                    if (!val?.utr_number) {
                        isTrue = true;
                        errorMsg = 'UTR no is missing';
                        return;
                    }
                    if (!val?.mode_of_payment) {
                        isTrue = true;
                        errorMsg = 'Mode of payment is missing';
                        return;
                    }
                    if (!val?.fc_closure_amount_proof) {
                        isTrue = true;
                        errorMsg = 'Amount proof is missing';
                        return;
                    }
                });
            }

            if (inputList[0]['payment_details']['prev_loan_closure'] === 'Bank') {
                bankAmountLoanReceived.some(val => {
                    if (!val?.loan_amount_received_from_bank) {
                        isTrue = true;
                        // toast.error("Amount received from bank is missing");
                        errorMsg = "Amount received from bank is missing";
                        return;
                    }

                    if (!val?.bank_transfer_utr_number) {
                        isTrue = true;
                        errorMsg = "Bank transfer utr no is missing";
                        // toast.error("Bank transfer utr no is missing");
                        return;
                    }
                });
            }


            if (ucdCaseByIdResponse?.data?.loan_approved_amount < totalReceivedAmount) {
                toast.error("Total received amount can't be greater than approved amount!");
                return;
            }

            // if (!list[0].payment_details['disbursal_date']) {
            //     isTrue = true;
            //     toast.error("Disbursal date is missing!");
            //     return;
            // }
            //
            // if (!list[0].payment_details['disbursal_memo']) {
            //     isTrue = true;
            //     toast.error("Disbursal memo is missing!");
            //     return;
            // }

            if (isTrue && errorMsg) {
                toast.error(errorMsg)
                isTrue ? setStage(stageNo - 1) : setStage(stageNo);
                return;
            }
            // if (ucdCaseByIdResponse?.data?.bank_transfer_loan_details &&
            //     ucdCaseByIdResponse?.data?.bank_transfer_loan_details.length > 0 &&
            //     ucdCaseByIdResponse?.data?.bank_transfer_loan_details[0] &&
            //     ucdCaseByIdResponse?.data?.bank_transfer_loan_details[0]?.loan_amount_received_from_bank) {
            //     if (isTrue && errorMsg) {
            //         toast.error(errorMsg)
            //         isTrue ? setStage(stageNo - 1) : setStage(stageNo);
            //     } else {
            //         setStage(stageNo)
            //     }
            //
            //     return false;
            // }


            Object.keys(list[0].payment_details).forEach((key) => {
                if (list[0].payment_details['existing_loan'] === 'No') {
                    // isTrue = !list[0].payment_details['loan_amount_from_bank'];
                    // isTrue = !list[0].payment_details['utr_no'];
                } else {
                    if (!list[0].payment_details[key] && list[0]['payment_details']['prev_loan_closure'] === 'Bank') {
                        errorMsg = key.charAt(0).toUpperCase().replaceAll("_", " ") + key.slice(1).replaceAll("_", " ") + " is required";
                        isTrue = true;
                    }
                }
                // isTrue = !list[0].payment_details['disbursal_date'];
                // if (!list[0].payment_details['disbursal_memo']) {
                //     setCheckDisbursalMemo(true)
                //     isTrue = true
                // }
            })
        }

        if (ucdCaseByIdResponse?.data?.bank_transfer_loan_details &&
            ucdCaseByIdResponse?.data?.bank_transfer_loan_details.length > 0 &&
            ucdCaseByIdResponse?.data?.bank_transfer_loan_details[0]?.loan_amount_received_from_bank) {
            setStage(stageNo);
            return;
        }
        // if (stageNo - 1 === 2) {
        //     Object.keys(list[0].dealer_details).forEach((key) => {
        //         if (!list[0].dealer_details[key]) {
        //             isTrue = true;
        //         }
        //     })
        // }

        if (stageNo - 1 === 3) {
            Object.keys(list[0].hold_back_Details).forEach((key) => {
                if (!list[0].hold_back_Details[key] && key !== 'amount_approval_proof' && key !== 'status') {
                    isTrue = true;
                }

                if (parseInt(amountReceived) !== parseInt(list[0].hold_back_Details['amount']) && key === 'amount_approval_proof' && !list[0].hold_back_Details[key]) {
                    errorMsg = "Document for amount proof is required!";
                    isTrue = true;
                }
            })
        }

        if (stageNo - 1 === 4) {
            tranches.map(val => {
                console.log(val)
                Object.keys(val).forEach((key) => {
                    if (!key) {
                        isTrue = true;
                    }
                })
            })
        }
        if (isTrue && errorMsg) {
            toast.error(errorMsg)
        }
        isTrue ? setStage(stageNo - 1) : setStage(stageNo);

    }
    useEffect(() => {
        if (parseInt(loanPaymentRaiseUpdateResponse?.status) === 200) {
            toast.success(loanPaymentRaiseUpdateResponse?.message);
            if (match?.params?.dealer_id) {
                window.location.href = `${baseUrl}/ucd/case-list/${match?.params?.dealer_id}/${match?.params?.id}`
            } else {
                window.location.href = `${baseUrl}/ucd/lead/logged-in`
            }

        } else if (parseInt(loanPaymentRaiseUpdateResponse?.status) !== 200) {
            toast.error(loanPaymentRaiseUpdateResponse?.message);
        }
    }, [loanPaymentRaiseUpdateResponse])

    useEffect(() => {
        if (parseInt(loanPaymentRaiseResponse?.status) === 200) {
            toast.success(loanPaymentRaiseResponse?.message);
            if (match?.params?.dealer_id) {
                window.location.href = `${baseUrl}/ucd/case-list/${match?.params?.dealer_id}/${match?.params?.id}`
            } else {
                window.location.href = `${baseUrl}/ucd/lead/logged-in`
            }
        } else if (parseInt(loanPaymentRaiseResponse?.status) !== 200) {
            toast.error(loanPaymentRaiseResponse?.message);
        }
    }, [loanPaymentRaiseResponse])

    useEffect(() => {
        if (loanTranchesResponse?.data) {
            let list = [...inputList];

            setIsEdit(true)
            if (loanTranchesResponse?.data?.HOLD_BACK_TRANCHE) {
                list[0]['hold_back_Details']['account_id'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.account_id;
                list[0]['hold_back_Details']['mode_of_payment'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.payment_mode;
                list[0]['hold_back_Details']['remark'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.remark;
                list[0]['hold_back_Details']['status'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.status;
                if (loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.utr_number) {
                    list[0]['hold_back_Details']['utr_number'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE[0]?.utr_number;
                }
                if (loanTranchesResponse?.data?.TRANCHES.length > 0) {
                    setTranches(loanTranchesResponse?.data?.TRANCHES)
                }
            }

            list[0]['dealer_details'] = {
                account_number: loanAccountResponse?.DEALER?.account_number,
                bank_name: loanAccountResponse?.DEALER?.bank_name,
                ifsc_code: loanAccountResponse?.DEALER?.ifsc_code,
                branch_name: loanAccountResponse?.DEALER?.branch_name,
            };

            if (ucdCaseByIdResponse?.data) {
                list[0]['payment_details'] = {
                    existing_loan: ucdCaseByIdResponse?.data?.existing_loan ? "Yes" : "No",
                    for_closure_amount: ucdCaseByIdResponse?.data?.fore_closure_amount,
                    // fc_closure_amount_proof: ucdCaseByIdResponse?.data?.fore_closure_amount_proof,
                    mode_of_payment: ucdCaseByIdResponse?.data?.mode_of_payment,
                    // loan_amount_from_bank: ucdCaseByIdResponse?.data?.loan_amount_received_from_bank,
                    utr_no: ucdCaseByIdResponse?.data?.bank_transfer_utr_number,
                    // loan_closure_payment_proof: ucdCaseByIdResponse?.data?.loan_closure_payment_proof,
                    prev_loan_closure: ucdCaseByIdResponse?.data?.previous_loan_closed_by,
                    // disbursal_memo: ucdCaseByIdResponse?.data?.disbursal_memo,
                    // disbursal_date: ucdCaseByIdResponse?.data?.disbursal_date,
                };

                if (ucdCaseByIdResponse?.data?.bank_transfer_loan_details && ucdCaseByIdResponse?.data?.bank_transfer_loan_details.length > 0) {
                    // eslint-disable-next-line no-unused-expressions
                    ucdCaseByIdResponse?.data?.bank_transfer_loan_details.map((val, i) => {
                        if (!amountReceivedEdit[i]) {
                            amountReceivedEdit[i] = true;
                        }
                    })
                    setAmountReceivedEdit(amountReceivedEdit)
                    setBankAmountLoanReceived(ucdCaseByIdResponse?.data?.bank_transfer_loan_details);
                }
                if (ucdCaseByIdResponse?.data?.fore_closure_account_details && ucdCaseByIdResponse?.data?.fore_closure_account_details.length > 0) {
                    // eslint-disable-next-line no-unused-expressions
                    ucdCaseByIdResponse?.data?.fore_closure_account_details.map((val, i) => {
                        if (!accountHolderEdit[i]) {
                            accountHolderEdit[i] = true;
                        }
                        let bankList = [];
                        newBankDetailsResponse.map(val => {
                            bankList.push(val?.name)
                        })

                        accountHolder[i] = {
                            bank_name: bankList.includes(val?.bank_name) ? val?.bank_name : "Other",
                            account_number: val?.account_number,
                            ifsc_code: val?.ifsc_code,
                            branch_name: val?.branch_name,
                            fore_closure_amount: val?.fore_closure_amount,
                            utr_number: val?.utr_number,
                            mode_of_payment: val?.mode_of_payment,
                            fc_closure_amount_proof: val?.fore_closure_amount_proof,
                            tranche_id: val?.tranche_id ?? null,
                            tranche_status: val?.tranche_status !== 'REQUEST_FOR_MODIFICATION',
                            other_bank: !bankList.includes(val?.bank_name) ? val?.bank_name : '',
                        };
                    })

                    setAccountHolderEdit(accountHolderEdit)
                    setAccountHolder(accountHolder)
                }

                list[0]['hold_back_Details']['amount'] = ucdCaseByIdResponse?.data?.hold_back_amount ?? null;
                list[0]['hold_back_Details']['amount_approval_proof'] = ucdCaseByIdResponse?.data?.hold_back_amount_proof;


                let amount = 0;
                if (!list[0]['hold_back_Details']['amount']) {
                    if (parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) <= 1000000) {
                        amount = 20000;
                    } else if (parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) > 1000000 && parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) < 2000000) {
                        amount = 40000;
                    }
                    if (amount) {
                        handleInput(amount, 'amount', '', 'hold_back_Details');
                    }
                    setAmountReceived(amount);
                }

            }
            setInputList(list)
        }
    }, [loanTranchesResponse, ucdCaseByIdResponse, loanAccountResponse, newBankDetailsResponse]);

    const handlePaymentRelease = async () => {
        setIsLoading(true)
        await loanApprovalRequestRequest({ loan_id: match?.params?.id, status: "REQUEST_FOR_PAYMENT_RELEASE" })
        setIsLoading(false)
    }

    useEffect(() => {
        let amount = 0;
        if (!ucdCaseByIdResponse?.data) {
            return;
        }
        if (parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) <= 1000000) {
            amount = 20000;
        } else if (parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) > 1000000 && parseInt(ucdCaseByIdResponse?.data?.loan_approved_amount) < 2000000) {
            amount = 40000;
        }

        console.log("amount", ucdCaseByIdResponse?.data?.loan_approved_amount)
        if (amount) {
            handleInput(amount, 'amount', '', 'hold_back_Details',);
        }

        setAmountReceived(amount);

    }, [ucdCaseByIdResponse]);

    useEffect(() => {
        if (parseInt(loanApprovalRequestResponse?.status) === 200) {
            toast.success(loanApprovalRequestResponse?.message);
            if (match?.params?.dealer_id) {
                window.location.href = `${baseUrl}/ucd/case-list/${match?.params?.dealer_id}/${match?.params?.id}`
            } else {
                window.location.href = `${baseUrl}/ucd/lead/logged-in`
            }
        } else if (parseInt(loanApprovalRequestResponse?.status) !== 200) {
            toast.error(loanApprovalRequestResponse?.message);
        }
    }, [loanApprovalRequestResponse])

    // useEffect(() => {
    //     if(loanAccountResponse?.data && loanAccountResponse?.data?.DEALER){
    //         let list = [...inputList];
    //         list['dealer_details'] = {
    //             account_number: loanAccountResponse?.data?.DEALER?.account_number,
    //             bank_name: loanAccountResponse?.data?.DEALER?.bank_name,
    //             ifsc_code: loanAccountResponse?.data?.DEALER?.ifsc_code,
    //             branch_name: loanAccountResponse?.data?.DEALER?.branch_name,
    //         };
    //         setInputList(list)
    //     }
    // }, [loanAccountResponse])
    //
    // useEffect(() => {
    //     if(loanTranchesResponse?.loan_details){
    //         let list = [...inputList];
    //
    //         if(loanTranchesResponse?.data?.HOLD_BACK_TRANCHE){
    //             list[0]['hold_back_Details']['account_id'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE?.account_id;
    //             list[0]['hold_back_Details']['mode_of_payment'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE?.payment_mode;
    //             list[0]['hold_back_Details']['remark'] = loanTranchesResponse?.data?.HOLD_BACK_TRANCHE?.remark;
    //             setTranches(loanTranchesResponse?.data?.TRANCHES)
    //         }
    //         setInputList(list)
    //     }
    // }, [loanTranchesResponse]);

    // useEffect(() => {
    //     if(ucdCaseByIdResponse?.data){
    //         setTimeout(() => {
    //             let list = [...inputList];
    //             list[0]['payment_details'] = {
    //                 existing_loan: ucdCaseByIdResponse?.data?.existing_loan ? "Yes": "No",
    //                 for_closure_amount: ucdCaseByIdResponse?.data?.fore_closure_amount,
    //                 fc_closure_amount_proof: ucdCaseByIdResponse?.data?.fore_closure_amount_proof,
    //                 mode_of_payment: ucdCaseByIdResponse?.data?.mode_of_payment,
    //                 loan_amount_from_bank: ucdCaseByIdResponse?.data?.loan_amount_received_from_bank,
    //                 utr_no: ucdCaseByIdResponse?.data?.branch_name,
    //                 loan_closure_payment_proof: ucdCaseByIdResponse?.data?.loan_closure_payment_proof,
    //             };
    //
    //             list[0]['hold_back_Details']['amount'] = ucdCaseByIdResponse?.data?.hold_back_amount ?? null;
    //             list[0]['hold_back_Details']['amount_approval_proof'] = ucdCaseByIdResponse?.data?.hold_back_amount_proof ?? null;
    //             setInputList(list)
    //         }, 500)
    //     }
    // }, [ucdCaseByIdResponse]);

    const handleAddAccountHolder = () => {
        setAccountHolder([
            ...accountHolder, {
                fore_closure_amount: "",
                account_number: '',
                bank_name: '',
                ifsc_code: '',
                branch_name: '',
                other_bank: '',
                utr_no: '',
                tranche_id: '',
                mode_of_payment: '',
                fc_closure_amount_proof: ''
            }
        ]);
    }

    const handleRemoveAccountHolder = (e, index) => {
        e.preventDefault();
        let list = [...accountHolder]
        list.splice(index, 1);
        setAccountHolder(list)
    }

    const handleAccountHolderInput = (val, key, index) => {
        const list = [...accountHolder]
        list[index][key] = val
        setAccountHolder(list)
    }

    useEffect(() => {
        if (checkDisbursalMemo) {
            toast.error("Disbursal memo is missing!");
        }
        setCheckDisbursalMemo(false);
    }, [checkDisbursalMemo]);

    console.log("foreClosureAddAccountResponse", foreClosureAddAccountResponse)
    useEffect(() => {
        if (parseInt(foreClosureAddAccountResponse?.status) === 200) {
            setIsAccountCreated(true)
        } else if (parseInt(foreClosureAddAccountResponse?.status) !== 200) {
            toast.error(foreClosureAddAccountResponse?.message);
        }
    }, [foreClosureAddAccountResponse])

    return (
        <>
            <Layout
                title={"Add New Case"}
                isLoading={isLoading}
                isGoback={true}
            >
                <div className="container-fluid">
                    <div className="container-v2">
                        <link rel="stylesheet"
                            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.0.3/css/font-awesome.css" />
                        <div id="msform">
                            <ul id="progressbar">
                                <li id="confirm" className={`${(stage < 2) ? 'active' : 'done'}`}><span
                                    className='pb-v2'><strong>Payment</strong></span></li>
                                <li id="confirm"
                                    className={`${(stage == 2) ? 'active' : (stage > 2) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Dealer</strong></span></li>
                                <li id="confirm"
                                    className={`${(stage == 3) ? 'active' : (stage > 3) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Hold Back Amount</strong></span>
                                </li>
                                <li id="confirm"
                                    className={`${(stage == 4) ? 'active' : (stage > 4) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Tranches</strong></span>
                                </li>
                                <li id="confirm"
                                    className={`${(stage == 5) ? 'active' : (stage > 5) ? 'done' : 'inactive'}`}>
                                    <span className='pb-v2'><strong>Undertaking</strong></span>
                                </li>
                            </ul>


                        </div>
                    </div>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        {stage === 1 &&
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <DropDownInput
                                                label={'Existing Loan'}
                                                data={[{ id: "Yes", name: "Yes" }, {
                                                    id: "No",
                                                    name: "No"
                                                }]}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, 'existing_loan', '', 'payment_details')
                                                }}
                                                value={inputList[0]['payment_details']['existing_loan']}
                                                isStarRequired={true}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        {inputList[0]['payment_details']['existing_loan'] === 'Yes' &&
                                            <>
                                                <div
                                                    className="col-md-6">
                                                    <ConstantInput
                                                        label={"For Closure Amount"}
                                                        handleChange={(val) =>
                                                            handleInput(val, 'for_closure_amount', '', 'payment_details')
                                                        }
                                                        value={inputList[0]['payment_details']['for_closure_amount']}
                                                        type="number"
                                                        required={true}
                                                        isStarRequired={true}
                                                        decimal={"decimal"}
                                                        step={"any"}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <DropDownInput
                                                        label={'Previous Loan Closure By'}
                                                        data={[{ id: "Bank", name: "Bank" }, {
                                                            id: "Park+",
                                                            name: "Park+"
                                                        }]}
                                                        getIdValue={(val) => {
                                                            handleInput(val.id, 'prev_loan_closure', '', 'payment_details')
                                                        }}
                                                        value={inputList[0]['payment_details']['prev_loan_closure'] ? inputList[0]['payment_details']['prev_loan_closure'] : ""}
                                                        required={true}
                                                        isStarRequired={true}
                                                    />
                                                </div>

                                                {inputList[0]['payment_details']['prev_loan_closure'] === 'Bank' &&
                                                    <div
                                                        className="col-md-6 float-field mb-3">
                                                        <ConstantInput
                                                            label={"Transaction Proof No"}
                                                            handleChange={(val) =>
                                                                handleInput(val, 'utr_no', '', 'payment_details')
                                                            }
                                                            value={inputList[0]['payment_details']['utr_no']}
                                                            type="text"
                                                            required={true}
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                }
                                                {inputList[0]['payment_details']['prev_loan_closure'] === 'Park+' &&
                                                    <div className="card">
                                                        <div
                                                            className="card-header">{"Fore Closure Accounts Details"}</div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                {accountHolder.map((val, i) => {
                                                                    return (
                                                                        <>
                                                                            <div className="card">
                                                                                <div
                                                                                    className="card-header">{"Fore Closure Accounts Details"}</div>
                                                                                <div className="card-body">
                                                                                    <div className="row">
                                                                                        <div
                                                                                            className="col-sm-6 float-field mb-3">
                                                                                            <ConstantInput
                                                                                                label={"Amount to be transferred"}
                                                                                                handleChange={(value) =>
                                                                                                    handleAccountHolderInput(value, 'fore_closure_amount', i)
                                                                                                }
                                                                                                type="number"
                                                                                                required={true}
                                                                                                isStarRequired={true}
                                                                                                value={val?.fore_closure_amount}
                                                                                                disabled={accountHolderEdit[i]}
                                                                                                decimal={"decimal"}
                                                                                                step={"any"}
                                                                                            />
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-sm-6 float-field mb-3">
                                                                                            <ConstantInput
                                                                                                label={"Account Number"}
                                                                                                handleChange={(value) =>
                                                                                                    handleAccountHolderInput(value, 'account_number', i)
                                                                                                }
                                                                                                value={val?.account_number}
                                                                                                type="text"
                                                                                                required={true}
                                                                                                isStarRequired={true}
                                                                                                disabled={accountHolderEdit[i]}
                                                                                                checkDigits={true}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-sm-6">
                                                                                            <DropDownInput
                                                                                                label={'Bank Name'}
                                                                                                data={bankListResponse}
                                                                                                getIdValue={(value) => {
                                                                                                    handleAccountHolderInput(value.id, 'bank_name', i)
                                                                                                }}
                                                                                                value={val?.bank_name}
                                                                                                isStarRequired={true}
                                                                                                required={true}
                                                                                                disabled={accountHolderEdit[i]}
                                                                                            />
                                                                                        </div>
                                                                                        {val?.bank_name === 'Other' &&
                                                                                            <div
                                                                                                className="col-sm-6 float-field mb-3">
                                                                                                <ConstantInput
                                                                                                    label={"Bank Name"}
                                                                                                    handleChange={(value) =>
                                                                                                        handleAccountHolderInput(value, 'other_bank', i)
                                                                                                    }
                                                                                                    value={val?.other_bank}
                                                                                                    type="text"
                                                                                                    required={true}
                                                                                                    isStarRequired={true}
                                                                                                    disabled={accountHolderEdit[i]}
                                                                                                />
                                                                                            </div>
                                                                                        }
                                                                                        <div
                                                                                            className="col-sm-6 float-field mb-3">
                                                                                            <ConstantInput
                                                                                                label={"IFSC Code"}
                                                                                                handleChange={(value) =>
                                                                                                    handleAccountHolderInput(value, 'ifsc_code', i)
                                                                                                }
                                                                                                value={val?.ifsc_code}
                                                                                                type="text"
                                                                                                required={true}
                                                                                                isStarRequired={true}
                                                                                                maxLength={11}
                                                                                                minLength={11}
                                                                                                disabled={accountHolderEdit[i]}
                                                                                            />
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-sm-6 float-field mb-3">
                                                                                            <ConstantInput
                                                                                                label={"Branch Name"}
                                                                                                handleChange={(value) =>
                                                                                                    handleAccountHolderInput(value, 'branch_name', i)
                                                                                                }
                                                                                                value={val?.branch_name}
                                                                                                type="text"
                                                                                                required={true}
                                                                                                isStarRequired={true}
                                                                                                disabled={accountHolderEdit[i]}
                                                                                            />
                                                                                        </div>
                                                                                        <div
                                                                                            className="col-sm-6 float-field mb-3">
                                                                                            <ConstantInput
                                                                                                label={"UTR No"}
                                                                                                handleChange={(value) =>
                                                                                                    handleAccountHolderInput(value, 'utr_number', i)
                                                                                                }
                                                                                                value={val?.utr_number}
                                                                                                type="text"
                                                                                                required={true}
                                                                                                isStarRequired={true}
                                                                                                disabled={accountHolderEdit[i]}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-sm-6">
                                                                                            <DropDownInput
                                                                                                label={'Mode of payment'}
                                                                                                data={[{
                                                                                                    id: "DD",
                                                                                                    name: "DD"
                                                                                                }, {
                                                                                                    id: "RTGS",
                                                                                                    name: "RTGS"
                                                                                                }, {
                                                                                                    id: "NEFT",
                                                                                                    name: "NEFT"
                                                                                                }, {
                                                                                                    id: "Other",
                                                                                                    name: "Other"
                                                                                                }]}
                                                                                                getIdValue={(value) => {
                                                                                                    handleAccountHolderInput(value.id, 'mode_of_payment', i)
                                                                                                }}
                                                                                                value={val['mode_of_payment'] ? val['mode_of_payment'] : ""}
                                                                                                required={true}
                                                                                                isStarRequired={true}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="col-md-6 col-sm-12">
                                                                                            <FileUpload
                                                                                                id={"fc_closure_amount_proof " + i}
                                                                                                accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                                                                documentUploadUrl={documentUploadUrlPublic}
                                                                                                documentUrlData={documentUrlDataPublic}
                                                                                                onChange={(value) => handleAccountHolderInput(value, 'fc_closure_amount_proof', i)}
                                                                                                prefilledFilename={val['fc_closure_amount_proof'] ? "FC Closure Amount Proof" : ""}
                                                                                                width={"100%"}
                                                                                            >
                                                                                                <span className="btn btn-transparent"
                                                                                                    style={{ minWidth: '100%' }}>FC Closure Amount Proof
                                                                                                    <div style={{ color: "red" }}>*</div>
                                                                                                </span>
                                                                                            </FileUpload>
                                                                                        </div>
                                                                                        <div
                                                                                            className="btn-box mb-4"
                                                                                            style={{ "width": "100%" }}>
                                                                                            {accountHolder.length !== 1 && !accountHolderEdit[i] &&
                                                                                                <button
                                                                                                    onClick={(e) => handleRemoveAccountHolder(e, i)}
                                                                                                    className="btn btn-sm btn-danger ml-3"> -
                                                                                                    Remove
                                                                                                    Account
                                                                                                    Holder
                                                                                                </button>
                                                                                            }
                                                                                            {accountHolder.length - 1 === i &&
                                                                                                <button
                                                                                                    className="btn btn-sm btn-primary ml-3 mt-3"
                                                                                                    onClick={(e) => handleAddAccountHolder()}>+
                                                                                                    Add
                                                                                                    Account
                                                                                                    Holder
                                                                                                </button>
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                                {inputList[0]['payment_details']['prev_loan_closure'] === 'Bank' &&
                                                    <div className="col-sm-6">
                                                        <DropDownInput
                                                            label={'Mode of payment for Loan Closure'}
                                                            data={[
                                                                { id: "DD", name: "DD" },
                                                                { id: "RTGS", name: "RTGS" },
                                                                { id: "NEFT", name: "NEFT" },
                                                                { id: "Other", name: "Other" }
                                                            ]}
                                                            getIdValue={(val) => {
                                                                handleInput(val.id, 'mode_of_payment', '', 'payment_details')
                                                            }}
                                                            getValueById={inputList[0]['payment_details']['mode_of_payment']}
                                                            required={true}
                                                            isStarRequired={true}
                                                        />
                                                    </div>
                                                }

                                                {inputList[0]['payment_details']['prev_loan_closure'] === 'Bank' &&
                                                    <div className="col-md-6">
                                                        <FileUpload
                                                            id={"loan_closure_payment_proof"}
                                                            accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                            documentUploadUrl={documentUploadUrlPublic}
                                                            style={{ justifyContent: "flex-end" }}
                                                            documentUrlData={documentUrlDataPublic}
                                                            onChange={(value) => handleInput(value, 'loan_closure_payment_proof', '', 'payment_details')}
                                                            prefilledFilename={inputList[0]['payment_details']['loan_closure_payment_proof'] ? "Loan Closure Amount Proof" : ""}
                                                        >
                                                            <span className="btn btn-transparent">Loan Closure Amount Proof
                                                                <div style={{ color: "red" }}>*</div>
                                                            </span>
                                                        </FileUpload>
                                                    </div>
                                                }
                                            </>
                                        }
                                        {/*<div*/}
                                        {/*                                                    className="col-sm-6 float-field mb-3">*/}
                                        {/*                                                    <ConstantInput*/}
                                        {/*                                                        label={"Disbursal Date"}*/}
                                        {/*                                                        handleChange={(val) =>*/}
                                        {/*                                                            handleInput(val, 'disbursal_date', '', 'payment_details')*/}
                                        {/*                                                        }*/}
                                        {/*                                                        value={inputList[0]['payment_details']['disbursal_date']}*/}
                                        {/*                                                        type="date"*/}
                                        {/*                                                        required={true}*/}
                                        {/*                                                        isStarRequired={true}*/}
                                        {/*                                                    />*/}
                                        {/*                                                </div>*/}
                                        {/*                                                <div className="col-md-6 col-sm-12">*/}
                                        {/*                                                    <FileUpload*/}
                                        {/*                                                        id={"disbursal_memo"}*/}
                                        {/*                                                        accept=".pdf,.png,.jpg,.jpeg,.doc"*/}
                                        {/*                                                        documentUploadUrl={documentUploadUrlPublic}*/}
                                        {/*                                                        documentUrlData={documentUrlDataPublic}*/}
                                        {/*                                                        onChange={(value) => handleInput(value, 'disbursal_memo', '', 'payment_details')}*/}
                                        {/*                                                        prefilledFilename={inputList[0]['payment_details']['disbursal_memo'] ? "Disbursal Memo" :""}*/}
                                        {/*                                                        width={"100%"}*/}
                                        {/*                                                    >*/}
                                        {/*                                                    <span className="btn btn-transparent"*/}
                                        {/*                                                          style={{minWidth: '100%'}}>Disbursal Memo<div*/}
                                        {/*                                                        style={{color: "red"}}>*</div>*/}
                                        {/*                                                    </span>*/}
                                        {/*                                                    </FileUpload>*/}
                                        {/*                                                </div>*/}
                                    </div>

                                    <div className="card mt-4">
                                        <div className="card-header">{"Tranches"}</div>
                                        <div className="card-body">
                                            {bankAmountLoanReceived.map((value, index) => {
                                                return (
                                                    <>
                                                        <div key={index} className="row">
                                                            <div
                                                                className="col-md-6">
                                                                <ConstantInput
                                                                    label={"Loan Amount Received From Bank"}
                                                                    handleChange={(val) =>
                                                                        handleAmountReceivedFromBankInput(val, 'loan_amount_received_from_bank', index)
                                                                    }
                                                                    value={value['loan_amount_received_from_bank']}
                                                                    type="text"
                                                                    required={inputList[0]['payment_details']['prev_loan_closure'] === 'Bank'}
                                                                    isStarRequired={inputList[0]['payment_details']['prev_loan_closure'] === 'Bank'}
                                                                    disabled={amountReceivedEdit[index]}
                                                                    decimal={"decimal"}
                                                                    step={"any"}
                                                                    checkDigits={true}
                                                                />
                                                            </div>
                                                            <div
                                                                className="col-md-6">
                                                                <ConstantInput
                                                                    label={"UTR Number"}
                                                                    handleChange={(val) =>
                                                                        handleAmountReceivedFromBankInput(val, 'bank_transfer_utr_number', index)
                                                                    }
                                                                    value={value['bank_transfer_utr_number']}
                                                                    type="text"
                                                                    required={inputList[0]['payment_details']['prev_loan_closure'] === 'Bank'}
                                                                    isStarRequired={inputList[0]['payment_details']['prev_loan_closure'] === 'Bank'}
                                                                    disabled={amountReceivedEdit[index]}
                                                                />
                                                            </div>
                                                            <div
                                                                className="btn-box mb-4"
                                                                style={{ "width": "100%" }}>
                                                                {bankAmountLoanReceived.length !== 1 && !amountReceivedEdit[index] &&
                                                                    <button
                                                                        onClick={(e) => handleRemoveAmountReceivedFromBank(e, index)}
                                                                        className="btn btn-sm btn-danger ml-3">Remove
                                                                        Tranche
                                                                    </button>
                                                                }
                                                                {bankAmountLoanReceived.length - 1 === index &&
                                                                    <button
                                                                        className="btn btn-sm btn-primary ml-3 mt-1"
                                                                        onClick={(e) => handleAddAmountReceivedFromBank(e)}>Add
                                                                        Another
                                                                        Tranche
                                                                    </button>
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {stage === 2 &&
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div
                                            className="col-sm-6 float-field mb-3">
                                            <ConstantInput
                                                label={"Account Number"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'account_number', '', 'dealer_details')
                                                }
                                                value={loanAccountResponse?.DEALER?.account_number}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <DropDownInput
                                                label={'Bank Name'}
                                                data={bankListResponse}
                                                getIdValue={(val) => {
                                                    handleInput(val.id, 'bank_name', '', 'dealer_details')
                                                }}
                                                value={loanAccountResponse?.DEALER?.bank_name}
                                                isStarRequired={true}
                                                disabled={true}
                                            />
                                        </div>
                                        <div
                                            className="col-sm-6 float-field mb-3">
                                            <ConstantInput
                                                label={"IFSC Code"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'ifsc_code', '', 'dealer_details')
                                                }
                                                value={loanAccountResponse?.DEALER?.ifsc_code}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                disabled={true}
                                            />
                                        </div>
                                        <div
                                            className="col-sm-6 float-field mb-3">
                                            <ConstantInput
                                                label={"Branch Name"}
                                                handleChange={(val) =>
                                                    handleInput(val, 'branch_name', '', 'dealer_details')
                                                }
                                                value={loanAccountResponse?.DEALER?.branch_name}
                                                type="text"
                                                required={true}
                                                isStarRequired={true}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {stage === 3 &&
                            <>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-6 float-field mb-3">
                                                <ConstantInput
                                                    label={"Hold Back Amount"}
                                                    handleChange={(val) =>
                                                        handleInput(val, 'amount', '', 'hold_back_Details')
                                                    }
                                                    value={inputList[0]['hold_back_Details']['amount']}
                                                    type="text"
                                                    required={true}
                                                    isStarRequired={true}
                                                    disabled={inputList[0]['hold_back_Details']?.status === 'DISBURSED'}
                                                />
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <FileUpload
                                                    id={"amount_approval_proof"}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) => handleInput(val, 'amount_approval_proof', '', 'hold_back_Details')}
                                                    prefilledFilename={inputList[0]['hold_back_Details']['amount_approval_proof'] ? "Approval" : ""}
                                                    width={"100%"}
                                                >
                                                    <span className="btn btn-transparent"
                                                        style={{ minWidth: '100%' }}>
                                                        Approval
                                                        {inputList[0]['hold_back_Details']['amount'] !== amountReceived &&
                                                            <div style={{ color: "red" }}>*</div>
                                                        }</span>
                                                </FileUpload>
                                            </div>
                                            <div className="container-fluid">
                                                <div className="card">
                                                    <div
                                                        className="card-header">{"Hold Back Amount Release Tranches"}</div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <DropDownInput
                                                                    label={'Account'}
                                                                    data={loanAccountResponse?.accounts}
                                                                    getIdValue={(val) => {
                                                                        handleInput(val.id, 'account_id', '', 'hold_back_Details')
                                                                    }}
                                                                    value={inputList[0]['hold_back_Details']['account_number']}
                                                                    isStarRequired={true}
                                                                    required={true}
                                                                    disabled={inputList[0]['hold_back_Details']?.status === 'DISBURSED'}
                                                                />
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <DropDownInput
                                                                    label={'Mode of payment'}
                                                                    data={[
                                                                        { id: "DD", name: "DD" },
                                                                        { id: "RTGS", name: "RTGS" },
                                                                        { id: "NEFT", name: "NEFT" },
                                                                        { id: "Other", name: "Other" }
                                                                    ]}
                                                                    getIdValue={(val) => {
                                                                        handleInput(val.id, 'mode_of_payment', '', 'hold_back_Details')
                                                                    }}
                                                                    value={inputList[0]['hold_back_Details']['mode_of_payment']}
                                                                    disabled={inputList[0]['hold_back_Details']?.status === 'DISBURSED'}
                                                                    required={true}
                                                                    isStarRequired={true}
                                                                />
                                                            </div>
                                                            <div className="col-sm-6 float-field mb-3">
                                                                <ConstantInput
                                                                    label={"Remark"}
                                                                    handleChange={(val) =>
                                                                        handleInput(val, 'remark', '', 'hold_back_Details')
                                                                    }
                                                                    value={inputList[0]['hold_back_Details']['remark']}
                                                                    disabled={inputList[0]['hold_back_Details']?.status === 'DISBURSED'}
                                                                    type="text"
                                                                    required={true}
                                                                    isStarRequired={true}
                                                                />
                                                            </div>
                                                            {inputList[0]['hold_back_Details']?.status === 'DISBURSED' &&
                                                                <div className="col-sm-6 float-field mb-3">
                                                                    <ConstantInput
                                                                        label={"UTR Number"}
                                                                        value={inputList[0]['hold_back_Details']?.utr_number}
                                                                        type="text"
                                                                        required={true}
                                                                        isStarRequired={true}
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        }
                        {stage === 4 &&
                            <div className="card">
                                <div className="card-body">
                                {tranches.map((val, i) => {
                                    return (
                                        <div key={i} className="row">
                                            <div className="col-sm-6 float-field mb-3">
                                                <ConstantInput
                                                    label={"Tranche Amount"}
                                                    handleChange={(val) =>
                                                        handleTrancheInput(val, 'amount', i)
                                                    }
                                                    value={val?.amount}
                                                    type="text"
                                                    // required={true}
                                                    // isStarRequired={true}
                                                    disabled={val?.status === 'DISBURSED'}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <DropDownInput
                                                    label={'Account'}
                                                    data={loanAccountResponse?.accounts}
                                                    getIdValue={(val) => {
                                                        handleTrancheInput(val.id, 'account_id', i)
                                                    }}
                                                    value={val?.account_number}
                                                    // required={true}
                                                    // isStarRequired={true}
                                                    disabled={val?.status === 'DISBURSED'}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <DropDownInput
                                                    label={'Mode of payment'}
                                                    data={[{ id: "DD", name: "DD" }, {
                                                        id: "RTGS",
                                                        name: "RTGS"
                                                    }, { id: "NEFT", name: "NEFT" }, {
                                                        id: "Other",
                                                        name: "Other"
                                                    }]}
                                                    getIdValue={(val) => {
                                                        handleTrancheInput(val.id, 'payment_mode', i)
                                                    }}
                                                    disabled={val?.status === 'DISBURSED'}
                                                    value={val?.payment_mode}
                                                // required={true}
                                                // isStarRequired={true}
                                                />
                                            </div>
                                            <div className="col-sm-6 float-field mb-3">
                                                <ConstantInput
                                                    label={"Remark"}
                                                    handleChange={(val) =>
                                                        handleTrancheInput(val, 'remark', i)
                                                    }
                                                    value={val?.remark}
                                                    type="text"
                                                    required={true}
                                                    isStarRequired={true}
                                                    disabled={val?.status === 'DISBURSED'}
                                                />
                                            </div>
                                            {val?.status === 'DISBURSED' &&
                                                <div className="col-sm-6 float-field mb-3">
                                                    <ConstantInput
                                                        label={"UTR Number"}
                                                        value={inputList[0]['hold_back_Details']?.utr_number}
                                                        type="text"
                                                        required={true}
                                                        isStarRequired={true}
                                                        disabled={true}
                                                    />
                                                </div>
                                            }
                                            <div className="btn-box mb-4" style={{ width: "100%" }}>
                                                {tranches.length !== 1 && (
                                                    <button
                                                        onClick={(e) => handleRemoveTranches(e, i)}
                                                        className="btn btn-sm btn-danger ml-3">
                                                        - Remove Tranche
                                                    </button>
                                                )}
                                                {tranches.length - 1 === i && (
                                                    <button
                                                        className="btn btn-sm btn-primary ml-3 mt-3"
                                                        onClick={() => handleAddTranches()}>
                                                        + Add Another Tranche
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                                </div>
                            </div>
                        }

                        {stage === 5 &&
                            <>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12">
                                                <FileUpload
                                                    id={"Undertaking"}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) => handleInput(val, 'undertaking', '', 'undertaking')}
                                                    prefilledFilename={inputList[0]['undertaking']['undertaking'] ? "Undertaking" : ""}
                                                    width={"100%"}
                                                >
                                                    <span className="btn btn-transparent"
                                                        style={{ minWidth: '100%' }}>Undertaking</span>
                                                </FileUpload>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        }
                        <div className="col-md-12">
                        <div className="row d-flex mt-3" style={{justifyContent: "space-between"}}>
                            {parseInt(stage) > 1 && (
                            <button
                                className="btn btn-primary btn btn-sm"
                                onClick={() => handleStage(stage - 1)}
                            >
                                Go Back
                            </button>
                            )}
                            {parseInt(stage) <= 4 && (
                            <button
                                className="btn btn-primary btn btn-sm"
                                onClick={() => handleStage(stage + 1)}
                            >
                                Next
                            </button>
                            )}
                        </div>
                        </div>
                        {parseInt(stage) === 5 &&
                        <button className="btn btn-primary mt-5">
                            Submit
                        </button>
                        }
                        {ucdCaseByIdResponse?.data?.bank_transfer_loan_details &&
                            ucdCaseByIdResponse?.data?.bank_transfer_loan_details.length > 0 &&
                            ucdCaseByIdResponse?.data?.bank_transfer_loan_details[0] &&
                            ucdCaseByIdResponse?.data?.bank_transfer_loan_details[0]?.loan_amount_received_from_bank &&
                            <div className="col-md-12 mt-4">
                                <button
                                    className="btn btn-primary btn-user btn-block submit-btn-payment"
                                    onClick={handlePaymentRelease}
                                >
                                    Request For Payment Release
                                </button>
                            </div>
                        }
                    </form>
                </div>


            </Layout>
        </>
    );
};

export default PaymentRaiseV2;
